<template>
  <p class="clearfix mb-0">
    <span class="float-md-right d-block d-md-inline-block mt-25">
      <small>Recoventry Admin v{{ version }}</small>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    }
  },
}
</script>
